module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-nav', {
    staticClass: "sidebar",
    attrs: {
      "pills": "",
      "vertical": ""
    }
  }, _vm._l((_vm.menuItems), function(item) {
    return _c('li', {
      staticClass: "nav-item"
    }, [
      [_c('router-link', {
        staticClass: "nav-link",
        attrs: {
          "to": {
            name: item.name
          }
        }
      }, [_vm._v(_vm._s(item.title))])]
    ], 2)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d1e3a0d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 223
// module chunks = 1